





























































import { Component, Mixins, Prop } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import FormOrganizationInput from '@/components/registration/common/FormOrganizationInput.vue';
import RequiredFieldValidator from '@/components/registration/common/validation/RequiredFieldValidator.vue';
import { EducationModel } from '@/interfaces/registration/models/EducationModel';
import { EducationItem } from '@/interfaces/registration/EducationItem';
import { ListOption } from '@/interfaces/registration/ListOption';
import { Organization } from '@/interfaces/registration/Organization';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

@Component({
  components: {
    FormOrganizationInput,
    RequiredFieldValidator
  }
})
export default class EducationListing extends Mixins(FormFieldMixin) {
  @Prop({ default: () => { return {}; } }) readonly value!: EducationModel;

  $refs!: {
    inputDegree: Array<HTMLFormElement>;
  };

  @utils.State
  public years!: Array<ListOption>;

  @utils.State
  public educationRelationships!: Array<ListOption>;

  public removeEducation (index: number): void {
    if (this.value.educationItems[index].id as number > 0) {
      this.value.educationItems[index].delete = true;
    } else {
      this.$emit('input', { educationItems: this.value.educationItems.filter((value, i) => i !== index) });
    }
  }

  public addEducation (organization: Organization): void {
    if (organization !== undefined) {
      const newEducationItem: EducationItem = {
        id: 0,
        organization: organization
      };

      this.$emit('input', { educationItems: [...this.value.educationItems, ...[newEducationItem]] });

      this.$nextTick(() => this.$refs.inputDegree[this.$refs.inputDegree.length - 1].focus());
    }
  }

  get validationValue (): string {
    return this.value == null || this.value.educationItems == null || this.value.educationItems.length === 0 ? '' : 'valid';
  }
}
